
import {Component, Vue, Watch} from 'vue-property-decorator';
import virtualList from 'vue-virtual-scroll-list';
import stores from '@/stores';
import vPagination from '@/components/VuePlainPagination.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronEmpty from '@/components/NevronEmpty.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import CreateUser from './Create.vue';
import PerPageDropdown from '@/components/PerPageDropdown.vue';
import _ from 'lodash';
import ListNevronHeader from '@/components/ListNevronComponents/ListNevronHeader.vue';
import EmptyNevronHeader from '@/components/ListNevronComponents/EmptyNevronHeader.vue';

@Component({
  components: {
    virtualList,
    vPagination,
    ListNevronHeader,
    EmptyNevronHeader,
    Skeleton,
    NevronEmpty,
    NevronSearch,
    NevronSearchNoResults,
    CreateUser,
    PerPageDropdown,
  },
})

export default class UsersList extends Vue {
  watchSkip = true;
  response: any = null;
  items: IUser[] = [];
  perpage = 20;

  search: any = {
    query: '',
    current: '',
  };

  file: any = '';
  uploadResponse: any = '';
  exportData: any = '';

  message: any = {
    import: '',
    export: '',
    message: '',
  };

  // TODO
  indexList: number[] = [];
  allChecked: boolean = false;
  searchItems = _.debounce(() => {
    this.fetchData(1, this.search.query, this.perpage);
  }, 400); // fetches data with debounce (ms)

  /*
   * Watch for pagination
   */
  changedPage() {
    this.search.query = this.search.current;
    this.fetchData(this.response.currentPage, this.search.current, this.perpage);
  }

  perPageChange() {
    this.fetchData(1, '', this.perpage);
  }

  @Watch('uploadResponse')
  importCsv() {
    stores.User.importUsers(this.uploadResponse, 'account_user')
      .then((response) => {
        this.message.import = response.result;
        this.message.message = response.message;
        if (response.result === true) {
          this.refresh();
        }
      });
  }

  exportCSV() {
    stores.User.exportUsers('account_user')
      .then((response) => {
        this.exportData = response.data;
        if (response.result === true) {
          const csv = this.exportData;
          const anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
          anchor.target = '_blank';
          anchor.download = 'NevronAccountUsers.csv';
          anchor.click();
        }
        this.message.message = response.message;
        this.message.export = response.result;
      });
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    // set search query from URL
    if (this.$route.query.search) {
      this.search.query = this.$route.query.search;
      this.search.current = this.$route.query.search;
    }

    // set page from URL
    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    if (this.$route.query.perpage) {
      this.perpage = Number(this.$route.query.perpage);
    }
    this.fetchData(index, this.search.current, this.perpage)
      .then((response: any) => this.$watch('response.currentPage', this.changedPage));
  }

  /**
   * Fetches data on the specified page and with the specified query
   */
  fetchData(index: number | null, search: string | null, perpage: number | 20) {
    return stores.User.fetchData(index, search, perpage)
      .then((response: any) => {
        this.response = response;
        this.items = this.response.data;
        this.search.current = this.search.query;
        this.updateCheck();
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  importFile(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      this.uploadResponse = e.target ? e.target.result : '';
    };
    reader.readAsText(file);
  }

  refresh() {
    this.fetchData(this.response.currentPage, null, this.perpage);
  }

  /* removes or appends all items ids on current page to indexList */
  checkAll() {
    if (!this.allChecked) {
      this.indexList = Array.from(new Set([...this.indexList, ...this.itemIds]));
      this.allChecked = true;
    } else {
      this.indexList = this.indexList.filter((id) => !this.itemIds.includes(id));
      this.allChecked = false;
    }
  }

  /* when item is checked */
  updateCheck() {
    if (this.itemIds.every((id: number) => this.indexList.includes(id))) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  get itemIds(): number[] {
    return this.items.map((item: any) => item.id);
  }

  unknownClicked() {
    return null;
    // return new Promise((resolve, reject) => {
    //   axios.put(`/protected/users/search/set`,
    //   {
    //     ids: this.indexList,
    //     operation: 'unknown',
    //   })
    //   .then((response) => {
    //     console.log(response);
    //   }).catch((e) => {
    //     console.log(e);
    //     reject(e);
    //   });
    // });
  }

}
